import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import financeCalculatorData from "@data/finance-calculator/finance_calculator_data.json";
/**
 * Pure function that clones the calculation logic from InstallmentCalculatorContext.
 * Used by FinanceCarCard to recalculate finance values (e.g. monthly_installment)
 * when the API returns updated finance_calculator_data (e.g. after warranty selection).
 *
 * @param carCondition - 'used' | 'new' | 'chinese'
 * @param cashPrice - The car's cash price
 * @param isPreowned - Whether the car is preowned (affects tax calculation)
 * @param sliderState - Current calculator slider values (period, down_payment, last_payment, max percents)
 * @param dynamicFinanceData - Dynamic finance_calculator_data from the API (includes warranty cost)
 */
export function calculateFinanceValues(carCondition, cashPrice, isPreowned, sliderState, dynamicFinanceData) {
  var _sliderState$max_down, _sliderState$max_last, _values;
  // Resolve the finance values: prefer dynamic API data, then static JSON by car condition
  var values;
  if (dynamicFinanceData) {
    values = dynamicFinanceData;
  } else {
    if (carCondition === 'used') {
      values = financeCalculatorData.used;
    } else if (carCondition === 'new') {
      values = financeCalculatorData["new"];
    } else if (carCondition === 'chinese') {
      values = financeCalculatorData.chinese;
    }
    values = _objectSpread(_objectSpread({}, values), {}, {
      tax_rate: financeCalculatorData.tax_rate
    });
  }
  if (!values) return null;
  var max_down_payment_percent = (_sliderState$max_down = sliderState === null || sliderState === void 0 ? void 0 : sliderState.max_down_payment_percent) !== null && _sliderState$max_down !== void 0 ? _sliderState$max_down : 0.5;
  var max_last_payment_percent = (_sliderState$max_last = sliderState === null || sliderState === void 0 ? void 0 : sliderState.max_last_payment_percent) !== null && _sliderState$max_last !== void 0 ? _sliderState$max_last : 0.45;
  var period = sliderState !== null && sliderState !== void 0 && sliderState.period && sliderState.period !== 0 ? sliderState.period : values.installment_period;
  var cash_price = cashPrice;
  var tax_rate = values.tax_rate;
  var our_profit_percent = values.our_profit_rate;
  var total_car_price_without_tax = isPreowned ? cash_price : Math.round(cash_price / (1 + tax_rate));
  var profit_margin = ((_values = values) === null || _values === void 0 ? void 0 : _values.profit_margin) || 0;
  var total_car_price_with_our_profit = Math.round(total_car_price_without_tax * (1 + our_profit_percent)) + Number(profit_margin);
  var added_tax = Math.round(total_car_price_with_our_profit * tax_rate);
  var profit_margin_percent = values.profit_rate;
  var warranty = values.warranty || 0;
  var purchase_price = total_car_price_with_our_profit + added_tax;
  var insurance_percent = values.insurance;
  var insurance_value = Math.round(purchase_price * insurance_percent * (period / 12));
  var max_down_payment = Math.round(max_down_payment_percent * purchase_price);
  var max_last_payment = Math.round(max_last_payment_percent * purchase_price);
  var down_payment = typeof (sliderState === null || sliderState === void 0 ? void 0 : sliderState.down_payment) !== 'undefined' ? sliderState.down_payment : Math.round(values.first_payment * purchase_price);
  var last_payment = typeof (sliderState === null || sliderState === void 0 ? void 0 : sliderState.last_payment) !== 'undefined' ? sliderState.last_payment : Math.round(values.last_payment * purchase_price);
  var bank_profit = Math.round((purchase_price - down_payment) * profit_margin_percent * (period / 12));
  var total_financing_amount = purchase_price + insurance_value + bank_profit;
  var total_financing_amount_without_down_payment = total_financing_amount - down_payment + warranty;
  var monthly_installment = Math.ceil((total_financing_amount_without_down_payment - last_payment) / period);
  return {
    period: period,
    down_payment: down_payment,
    last_payment: last_payment,
    monthly_installment: monthly_installment,
    purchase_price: purchase_price,
    insurance_value: insurance_value,
    bank_profit: bank_profit,
    total_financing_amount: total_financing_amount,
    total_financing_amount_without_down_payment: total_financing_amount_without_down_payment,
    max_down_payment: max_down_payment,
    max_last_payment: max_last_payment
  };
}